/* global AOS*/
const aosAnimation = {

	init() {
		const aosSettings = {
			// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
			delay: 200 // values from 0 to 3000, with step 50ms
		}

		AOS.init(aosSettings)
	}
}

aosAnimation.init()